<template>
  <div class="navigation-list">
    <template v-if="!selectedRoute">
      <ul class="list">
        <li v-for="link in props.routes" :key="link.label" class="navigation-list__item">
          <NavigationItem
            :route="link"
            :disabled="isLinkDisabled(link)"
            @route-click="$emit('route-click')"
            @show-child-routes="selectedRoute = $event"
          />
        </li>
      </ul>

      <BaseButton
        class="navigation-list__logout"
        style-type="tertiary"
        aria-label="Logout"
        @click="$emit('logout')"
        >Logout</BaseButton
      >
    </template>

    <div v-else class="navigation-list__child-routes">
      <div class="navigation-list__item-wrapper">
        <BaseButton style-type="tertiary" @click="selectedRoute = null">
          Back

          <template #icon-left>
            <img src="@/assets/icons/chevron-blue-left.svg" alt="chevron-left" />
          </template>
        </BaseButton>
      </div>

      <div class="navigation-list__item-wrapper">
        <AppText type="bold" size="regular" class="navigation-list__child-routes-title">{{
          selectedRoute.label
        }}</AppText>
      </div>

      <ul class="navigation-list__child-list">
        <li
          v-for="childRoute in selectedRoute?.childRoutes"
          :key="childRoute.label"
          class="navigation-list__route-wrapper navigation-list__item_child"
        >
          <NavigationItem
            :route="childRoute"
            :disabled="isLinkDisabled(childRoute)"
            class="navigation-list__route"
            @route-click="$emit('route-click')"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';

  import BaseButton from '@/components/base/BaseButton.vue';
  import NavigationItem from '@/components/header/components/NavigationItem.vue';
  import AppText from '@/components/topography/AppText.vue';
  import { useOutcomeStore } from '@/stores';
  import { NavigationLink } from '@/types/interfaces';

  defineEmits<{
    (e: 'route-click'): void
    (n: 'logout'): void
  }>();

  const props = defineProps<{
    routes: NavigationLink[]
  }>();

  const selectedRoute = ref<NavigationLink | null>(null);

  const outcomeStore = useOutcomeStore();

  const isPositive = computed<boolean>(() => outcomeStore.isPositive);

  const isLinkDisabled = (link: NavigationLink): boolean =>
    !link.external && !!link.route && !isPositive.value;
</script>

<style scoped lang="scss">
  .navigation-list {
    display: flex;
    flex-direction: column;

    &__child-list,
    &__child-routes {
      padding: 0 16px;

      &-title {
        color: $text-100-link-blue;
      }
    }

    &__logout {
      align-self: center;
      margin-top: 16px;
    }

    &__item-wrapper {
      padding: 16px 0;
      border-bottom: 1px solid $light-navy-40;
    }

    &__route-wrapper,
    &__item {
      border-bottom: 1px solid $light-navy-40;
    }

    &__route {
      padding: 16px 0;
    }
  }
</style>
